import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import { get } from 'lodash';
import {LocalStorageService} from "../../../../shared/services/local-storage.service";
import { CustomCookieService } from '../../../../shared/services/custom-cookie.service';
import {AuthMode} from "../../../../shared/common/classes";
import { AuthorizationService } from '../../../../shared/services/authorization.service';
import { PlansManagementService } from '../../../../shared/services/plans-management.service';
@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss']
})
export class SignInComponent implements OnInit {
  public eligibilityForm: FormGroup;
  public logInForm: FormGroup;
  public authMode: AuthMode;

  constructor(
    public router: Router,
    private activatedRoute: ActivatedRoute,
    private localStorage: LocalStorageService,
    private customCookieService: CustomCookieService,
    private authorizationService: AuthorizationService,
    private plansManagementService: PlansManagementService
  ) {
  }

  ngOnInit(): void {
    this.initBehaviourSchema('light-sign-in')
  }


  private initBehaviourSchema(mode: AuthMode): any {
    this.authMode = 'light-sign-in';
    this.localStorage.saveData('mode', this.authMode)
    this.eligibilityForm = new FormGroup(
      {
        phone: new FormControl(''),
        zip: new FormControl('')
      }
    )
  }

  public onCheckEligibility() {
    this.plansManagementService.getMDNList().subscribe({
      next: (item: any)=>{
        console.log(item);
        this.customCookieService.saveData('mtnList', get(item,'[0].mtnList'))
        this.customCookieService.saveData('billAccountNumber', get(item,'[0].billAccountNumber'))
        this.router.navigate(['account/mdn']);
      },
      error: (error: Error) => {
        this.router.navigate(['main/eligibility-error']);
      }
    })
  }

  public onSignIn() {
    this.router.navigate(['account/mdn'])
  }



}
